"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
const identifiers_1 = require("./identifiers");
const updateCourse_1 = require("./updateCourse");
function addCourse({ name, description, ownerId, enrollmentCode, grade = null, domainId, noOfStudents = 0, creationMode = identifiers_1.Types.CreationModes.MANUAL, googleClassRoomInfo }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const insertObj = {
                name,
                description,
                ownerId,
                creationTime: new Date().toISOString(),
                updateTime: new Date().toISOString(),
                enrollmentCode,
                grade,
                creationMode,
                domainId,
                noOfStudents,
                courseState: identifiers_1.Types.CourseStates.ACTIVE,
                googleClassRoomInfo: null
            };
            const updateObj = {
                name,
                description,
                ownerId,
                creationTime: new Date().toISOString(),
                updateTime: new Date().toISOString(),
                enrollmentCode,
                grade,
                creationMode,
                domainId,
                courseState: identifiers_1.Types.CourseStates.ACTIVE,
                googleClassRoomInfo
            };
            const coursesWithSameEnrollmentCode = yield app_1.app.firestore.collection(`courses`)
                .where('enrollmentCode', '==', enrollmentCode)
                .where('ownerId', '==', ownerId)
                .get();
            if (coursesWithSameEnrollmentCode.empty) {
                return yield createCourseDoc(insertObj);
            }
            else {
                console.log(`Course with given enrollmentCode already exists. Courses :`, coursesWithSameEnrollmentCode.docs[0].data());
                return yield updateExistingCourseDoc(coursesWithSameEnrollmentCode, updateObj);
            }
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = addCourse;
function createCourseDoc(insertObj) {
    return __awaiter(this, void 0, void 0, function* () {
        const docRef = yield app_1.app.firestore.collection(`courses`).add(insertObj);
        // console.log('Document written with ID: ', docRef.id);
        // return `Added new course with given enrollment code '${insertObj.enrollmentCode}'.`;
        return { id: docRef.id, alreadyExists: false };
    });
}
function updateExistingCourseDoc(coursesWithSameEnrollmentCode, insertObj) {
    return __awaiter(this, void 0, void 0, function* () {
        for (const courseWithSameEnrollmentCode of coursesWithSameEnrollmentCode.docs) {
            yield updateCourse_1.default(courseWithSameEnrollmentCode.id, insertObj);
        }
        return {
            id: coursesWithSameEnrollmentCode.docs[0].id,
            alreadyExists: true,
            message: `Course with given enrollment code '${insertObj.enrollmentCode}' already exists.
    Updated the already existing course fields with provided values.`
        };
    });
}
//# sourceMappingURL=addCourse.js.map